// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-billing[data-v-2bdae3d8] {\n  background-color: #ffffff;\n  width: 100%;\n}\n.darkmode .card-billing[data-v-2bdae3d8] {\n  background-color: rgba(255, 236, 202, 0.05);\n}", ""]);
// Exports
module.exports = exports;
